import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EmailService } from 'src/app/services/email.service'
import { Email } from 'src/app/models/email.model';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Utils } from 'src/app/utils/utils';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {
  formParamEmail: FormGroup;
  idEleicao: any;
  emailDados: Email = new Email();
  tokenAuth: any;
  editando: boolean = false;
  idEmail: any;
  btOff: boolean = false;
  eleicaoParametrizando: any;

  constructor(
    public spinner: NgxSpinnerService,
    public emailService: EmailService,
    protected formBuilder: FormBuilder,
    public utils: Utils,
    protected messageService: MessageService
  ) { }

  async ngOnInit() {
    this.eleicaoParametrizando = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.idEleicao = this.eleicaoParametrizando.id;
    this.tokenAuth = sessionStorage.getItem("token");
    
    this.formParamEmail = new FormGroup({
      assunto: new FormControl(),
      titulo: new FormControl(),
      mensagem: new FormControl()
    })
    this.formParamEmail = this.formBuilder.group({
      assunto: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      titulo: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      mensagem: ['', [Validators.required, this.utils.noWhitespaceValidator]]
    })

    if(this.eleicaoParametrizando.enviaEmails == true || this.eleicaoParametrizando.enviaEmails == "true"){
      this.listarDadosExistentes();
    } else {
      this.formParamEmail.disable();
      this.btOff = true;
    }
  }

  listarDadosExistentes(){
    this.emailService.listarPorIdEleicao(this.idEleicao, this.tokenAuth).then((data: any) => {
      this.editando = true;
      this.formParamEmail.patchValue(data);
      this.idEmail = data.id;
    }, err => {
      console.log(err); //TODO
    })
  }

  submit() {
    if(!this.formParamEmail.valid){
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Preencha todos os campos obrigatórios!" })
    }
    this.btOff = true;
    document.body.style.cursor = 'wait';
    this.emailDados.titulo = this.formParamEmail.get('titulo').value;
    this.emailDados.assunto = this.formParamEmail.get('assunto').value;
    this.emailDados.mensagem = this.formParamEmail.get('mensagem').value;
    this.emailDados.eleicao = {"id": this.idEleicao};
    if(this.editando == false){
      this.spinner.show();
      this.emailService.salvarEmailEleicao(this.emailDados, this.tokenAuth).then(data => {
        this.spinner.hide();
        this.messageService.add({ key: 'toast', severity: 'success', summary: '', detail: "Dados para envio do email inseridos com sucesso" });
        this.btOff = false;
        document.body.style.cursor = 'default';
      }, err =>{
        this.spinner.hide();
        this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.error + ' ' + err.error.message, detail: "" });
        document.body.style.cursor = 'default';
        this.btOff = false;
        console.log(err);
      })
    }else{
      this.emailService.editarEmailEleicao(this.idEmail, this.emailDados, this.tokenAuth).then(data => {
        document.body.style.cursor = 'default';
        this.btOff = false;
        this.messageService.add({ key: 'toast', severity: 'success', summary: '', detail: "Dados do email atualizados" });
      }, err =>{
        this.messageService.add({ key: 'toast', severity: 'error', summary: err.error, detail: "" });
        console.log(err);
        document.body.style.cursor = 'default';
        this.btOff = false;
      })
    }
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Insira as informações aqui',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage','insertVideo','insertHTML']
    ]
  };
  
}
